import heroWebp1280 from "@/assets/hero-meeting-1280.webp";
import heroWebp800 from "@/assets/hero-meeting-800.webp";
import heroJpg1280 from "@/assets/hero-meeting-1280.jpg";

export const Hero = () => {
  return (
    <section className="max-w-[1280px] mx-auto px-6 lg:px-8 pt-16 lg:pt-24 pb-20 lg:pb-32">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 animate-fade-up">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-surface rounded-full text-ink-muted text-sm font-medium mb-8 ring-1 ring-ink/5">
            <span className="size-2 rounded-full bg-oak" />
            För föreningar i hela Sverige
          </div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-[4.25rem] leading-[1.05] tracking-tight text-balance mb-8">
            Låt oss ta hand om pappersarbetet,{" "}
            <span className="text-oak italic">så kan ni</span> ta hand om föreningen.
          </h1>
          <p className="text-lg text-ink-muted leading-relaxed text-pretty max-w-[48ch] mb-10">
            Vi sköter löpande bokföring, ekonomi och administration åt er. Se oss som en extra
            resurs i styrelsen, fast med stenkoll på siffrorna.
          </p>

          <div className="flex flex-wrap items-center gap-5">
            <a
              href="#kontakt"
              className="bg-oak text-paper px-8 py-4 rounded-full text-base font-medium hover:bg-oak-hover transition-all shadow-warm"
            >
              Kom igång idag
            </a>
            <a
              href="#tjanster"
              className="px-6 py-4 rounded-full text-base font-medium text-ink hover:bg-surface transition-colors"
            >
              Se våra tjänster →
            </a>
          </div>
        </div>

        <div className="lg:col-span-6 relative animate-fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="absolute -inset-4 bg-surface rounded-[2rem] -z-10 rotate-2" />
          <div className="relative bg-surface rounded-2xl overflow-hidden shadow-soft ring-1 ring-ink/10">
            <picture>
              <source
                type="image/webp"
                srcSet={`${heroWebp800} 800w, ${heroWebp1280} 1280w`}
                sizes="(min-width: 1024px) 50vw, 100vw"
              />
              <img
                src={heroJpg1280}
                alt="Tränare och föreningsrepresentanter skakar hand i sporthall"
                width={1280}
                height={1120}
                loading="eager"
                fetchPriority="high"
                decoding="async"
                className="w-full aspect-[8/7] object-cover"
              />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
};